exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "action-panel .action-panel {\n  display: -ms-flexbox;\n  display: flex; }\n  action-panel .action-panel.horizontal-items {\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: end;\n        justify-content: flex-end; }\n    action-panel .action-panel.horizontal-items.small-screen {\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n  action-panel .action-panel.vertical-items {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: center;\n        align-items: center; }\n  action-panel .action-panel .link-action {\n    font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/common-module/action-panel/action-panel.component.scss
// module id = ../../../../../src/app/common-module/action-panel/action-panel.component.scss
// module chunks = main